module.exports = __webpack_public_path__ + "static/media/civic-icon.dfacf35a.svg";